import { Heading, Text } from '@chakra-ui/react';
import { FC } from 'react';

import { Panel, IPanelProps } from '@/components/ui/core/Panel/Panel';

export const GroupPanel: FC<IPanelProps> = ({ heading, subheading, action, children, ...rest }) => {
  return (
    <Panel
      heading={
        <Heading as="h2" fontSize={['2xl', null, '3xl']} textTransform="capitalize">
          {heading}
        </Heading>
      }
      subheading={
        <Text as="div" fontSize="sm" fontWeight="medium" lineHeight="short" mt="2" role="doc-subtitle">
          {subheading}
        </Text>
      }
      action={action}
      {...rest}
    >
      {children}
    </Panel>
  );
};
